import React, { useMemo, useEffect } from 'react';
import Box from '@mui/material/Box';
import { Widget } from '@typeform/embed-react';
import { Button } from '@/components/atoms/Button/Button';

interface TypeformProps {
  className?: string;
  formID: string;
  isNativeApp?: boolean;
  onSubmit?: (this: Window, submitEvent: any) => void;
}

export const Typeform = ({
  className,
  isNativeApp,
  formID,
  onSubmit,
}: TypeformProps) => {
  const typeformTracking = useMemo(
    () => ({
      utm_source: isNativeApp
        ? 'karehero_typeform_native'
        : 'karehero_typeform',
    }),
    [isNativeApp],
  );

  const typeformUrl = useMemo(
    () =>
      `https://form.typeform.com/to/${formID}?utm_source=${typeformTracking.utm_source}`,
    [formID],
  );

  useEffect(() => {
    if (isNativeApp) window.location.href = typeformUrl;
  }, [isNativeApp, typeformUrl]);

  return isNativeApp ? (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <Button ariaLabel='Complete Survey' to={typeformUrl}>
        Complete Survey
      </Button>
    </Box>
  ) : (
    <Widget
      className={className}
      id={formID}
      onSubmit={onSubmit}
      tracking={typeformTracking}
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        borderRadius: 0,
      }}
    />
  );
};

Typeform.displayName = 'Typeform';

export default Typeform;
